import { render } from "./TabClassWork.vue?vue&type=template&id=590c61e0"
import script from "./TabClassWork.vue?vue&type=script&lang=js"
export * from "./TabClassWork.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__